"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactCommandType = exports.ContactCommandStatusReason = exports.ContactCommandStatus = void 0;
var ContactCommandStatus;
(function (ContactCommandStatus) {
    ContactCommandStatus["PENDING"] = "PENDING";
    ContactCommandStatus["COMPLETED"] = "COMPLETED";
})(ContactCommandStatus = exports.ContactCommandStatus || (exports.ContactCommandStatus = {}));
var ContactCommandStatusReason;
(function (ContactCommandStatusReason) {
    ContactCommandStatusReason["FAILED"] = "FAILED";
    ContactCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
})(ContactCommandStatusReason = exports.ContactCommandStatusReason || (exports.ContactCommandStatusReason = {}));
var ContactCommandType;
(function (ContactCommandType) {
    ContactCommandType["ARCHIVE"] = "ARCHIVE";
    ContactCommandType["CHANGE_ACCOUNT"] = "CHANGE_ACCOUNT";
    ContactCommandType["CREATE"] = "CREATE";
    ContactCommandType["MAKE_KEY_CONTACT"] = "MAKE_KEY_CONTACT";
    ContactCommandType["MIGRATE"] = "MIGRATE";
    ContactCommandType["REPLICATE"] = "REPLICATE";
    ContactCommandType["UNARCHIVE"] = "UNARCHIVE";
    ContactCommandType["UNSET_KEY_CONTACT"] = "UNSET_KEY_CONTACT";
    ContactCommandType["UPDATE"] = "UPDATE";
})(ContactCommandType = exports.ContactCommandType || (exports.ContactCommandType = {}));
//# sourceMappingURL=contact-command.js.map